import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import NamedByGod from './components/namedByGod';              // homepage
import NameDetail from './pages/NameDetail';                   // /name/:biblicalName
import About from './pages/About';                             // /about
import Join from './pages/Join';                               // /join
import { Flipbook } from './components/flipbook-component';    // sample PDF page

function App() {
  return (
    <Router>
      {/* Flex column so footer stays at bottom when content is short */}
      <div className="flex flex-col min-h-screen">
        <Header />

        {/* Main content grows to fill remaining space */}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<NamedByGod />} />
            <Route path="/about" element={<About />} />
            <Route path="/join" element={<Join />} />
            <Route path="/books/de-us" element={<Flipbook pdfUrl="/book_DE_US_20240428.pdf" />} />
            <Route path="/name/:biblicalName" element={<NameDetail />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
